import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function ArrowRightIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M8.70473 19.2947C8.31543 18.9054 8.31519 18.2743 8.70419 17.8847L14.58 12L8.70419 6.11528C8.31519 5.72568 8.31543 5.09458 8.70473 4.70528C9.09424 4.31577 9.72576 4.31577 10.1153 4.70528L16.7029 11.2929C17.0934 11.6834 17.0934 12.3166 16.7029 12.7071L10.1153 19.2947C9.72576 19.6843 9.09424 19.6843 8.70473 19.2947Z"
				fill="currentColor"
			/>
		</svg>
	);
}

ArrowRightIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ArrowRightIcon;
